// Shared dataset loader for the browser and Node. Blank lines (six of the seven CSVs end with one) are skipped.

export function parseCsv(text) {
    const lines = text.replace(/\r?\n$/, '').split(/\r?\n/);
    const header = lines[0].split(',');
    const rows = [];
    for (let i = 1; i < lines.length; i++) {
        if (lines[i] === '') continue;
        const values = lines[i].split(',');
        const row = {};
        header.forEach((h, j) => { row[h] = values[j]; });
        rows.push(row);
    }
    return { header, rows };
}

export function createDataset(name, csvText) {
    const { header, rows } = parseCsv(csvText);
    return { name, header, rows };
}

// Browser only.
export function fetchDataset(name) {
    return fetch('static/csv/' + name + '.csv')
        .then(response => response.text())
        .then(text => createDataset(name, text));
}
